import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { CustomTabs } from "sipli-fleet-core/components";
import CustomSharedTitleSection from "sipli-fleet-core/components/CustomSharedTitleSection/CustomSharedTitleSection";
import Change from "./Change";
import Install from "./Install";
import Uninstall from "./Uninstall";
import "./UnitsManagement.css";

const getActiveTabFromPath = (pathname: string) => {
  if (pathname.includes("/uninstall")) return "uninstall";
  if (pathname.includes("/change")) return "change";
  return "install";
};

const UnitsManagement = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(() => getActiveTabFromPath(pathname));

  useEffect(() => {
    setActiveTab(getActiveTabFromPath(pathname));
  }, [pathname]);

  const tabItems = [
    {
      key: "install",
      label: t("install_unit"),
      children: <Install />,
    },
    {
      key: "uninstall",
      label: t("uninstall_unit"),
      children: <Uninstall />,
    },
    {
      key: "change",
      label: t("change"),
      children: <Change />,
    },
  ];

  return (
    <section className="units-management-page bg-gray1 pb-8 pl-2">
      <CustomSharedTitleSection
        titleKey="device_management"
        titleClassName="!text-[25.23px] !font-[700]"
      />

      <CustomTabs
        activeKey={activeTab}
        items={tabItems}
        onChange={setActiveTab}
        className="device-management-tabs"
      />
    </section>
  );
};

export default UnitsManagement;
